import { render, staticRenderFns } from "./Pelaporan.vue?vue&type=template&id=c3f84ec2"
import script from "./Pelaporan.vue?vue&type=script&lang=js"
export * from "./Pelaporan.vue?vue&type=script&lang=js"
import style0 from "./Pelaporan.vue?vue&type=style&index=0&id=c3f84ec2&prod&lang=css"
import style1 from "./Pelaporan.vue?vue&type=style&index=1&id=c3f84ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports